import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, Input, InputNumber, Popconfirm, Space, Table, Upload, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import { ROUTES } from 'base/routes/routes';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter, Plus, Upload as UploadIcon } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { CustomerUnidentifiedModel } from 'services/Main/customerUnidentified_services';
import {
  commonPresenter,
  commonStore,
  contactSegmentStore,
  customerUnindentifiedPresenter,
  customerUnindentifiedStore
} from 'stores/root_store';
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';

const { RangePicker } = DatePicker;



// KHÁCH HÀNG CHƯA ĐỊNH DANH
const createCustomerUnidentified = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.kh-cdd') + ' - ' + SYSTEM_TITLE;
    const navigate = useNavigate();

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      customerCode: undefined,
      customerName: undefined,
    });
    // data table báo cáo
    const [dataTable, setDataTable] = useState<CustomerUnidentifiedModel[]>([]);

    const [listRowId, setListRowId] = useState<any[]>([])


    // ============================================================ STATE ==========================================================
    const [reportState, setReportState] = usePartialState({
      loading: false,
      download: false,
      import: false
    });
    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------

    const getDataTable = async (dataSearch: any) => {
      await customerUnindentifiedPresenter.getlistCustomerUnidentified(customerUnindentifiedStore, dataSearch);
      if (customerUnindentifiedStore.listCustomerUnidentified.isSuccess) {
        const dataTemp = cloneDeep(customerUnindentifiedStore.listCustomerUnidentified.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const [columns, setColumns] = useState<ProColumns<CustomerUnidentifiedModel>[]>([
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 70,
        align: 'center',
      },
      Table.SELECTION_COLUMN,

      //  Nguồn
      {
        title: t('unidentified.nguon'),
        dataIndex: 'source',
        key: 'source',
        fixed: 'left',
        width: 200,
      },
      // id
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 250,
        ellipsis: true,
        fixed: 'left',
      },
      // CompanyCode
      {
        title: 'Company code',
        dataIndex: 'companyCode',
        key: 'companyCode',
        width: 150,
      },
      // Tên công ty
      {
        title: 'Tên công ty',
        dataIndex: 'companyName',
        key: 'companyName',
        width: 200,
      },
      // Khu vực
      {
        title: t('search-form.area'),
        dataIndex: 'area',
        key: 'area',
        width: 150,
      },
      // Địa chỉ
      {
        title: t('search-form.address'),
        dataIndex: 'address',
        key: 'address',
        width: 200,
      },
      // Tỉnh/TP
      {
        title: t('search-form.province'),
        dataIndex: 'provinceName',
        key: 'provinceName',
        width: 150,
      },
      // Quận/Huyện
      {
        title: t('search-form.district'),
        dataIndex: 'districtName',
        key: 'districtName',
        width: 150,
      },
      // Phường/Xã
      {
        title: t('search-form.wards'),
        dataIndex: 'wardName',
        key: 'wardName',
        width: 150,
      },
      // Nguồn dữ liệu
      {
        title: 'Nguồn dữ liệu',
        dataIndex: 'dataSource',
        key: 'dataSource',
        width: 150,
      },
      // Thiết bị
      {
        title: t('unidentified.thiet-bi'),
        dataIndex: 'deviceName',
        key: 'deviceName',
        width: 150,
      },
      // Tên
      {
        title: t('unidentified.ten'),
        dataIndex: 'customerName',
        key: 'customerName',
        width: 170,
        // render: (text, record) => <Link to={''}>{text}</Link>,
      },
      //   Email
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        width: 250,
      },
      //   Số điện thoại
      {
        title: t('unidentified.sdt'),
        dataIndex: 'phone',
        key: 'phone',
        width: 100,
      },
      //   Chức vụ
      {
        title: 'Chức vụ',
        dataIndex: 'position',
        key: 'position',
        width: 150,
        ellipsis: true
      },
      //   Truy cập lần đầu
      {
        title: t('unidentified.truy-cap-lan-dau'),
        dataIndex: 'firstVisit',
        key: 'firstVisit',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY',
        },
        width: 120,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      //  Lượt truy cập 30 ngày qua
      {
        title: t('unidentified.tc-30day'),
        dataIndex: 'visitsLast30Days',
        key: 'visitsLast30Days',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text === '-' ? text : formatNumber(Number(text), 0)),
      },
      //  Lượt tải Catalogue
      {
        title: t('unidentified.luot-tai'),
        dataIndex: 'catalogDownloads',
        key: 'catalogDownloads',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text === '-' ? text : formatNumber(Number(text), 0)),
      },
      //  Số lượng sp yêu thích
      {
        title: t('unidentified.sp-yt'),
        dataIndex: 'numberOfFavoriteProducts',
        key: 'numberOfFavoriteProducts',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text === '-' ? text : formatNumber(Number(text), 0)),
      },
      //  Lượt đk map màu
      {
        title: t('unidentified.dk-map'),
        dataIndex: 'numberOfColorMap',
        key: 'numberOfColorMap',
        width: 100,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text === '-' ? text : formatNumber(Number(text), 0)),
      },
      // Ngày import
      {
        title: 'Ngày import',
        dataIndex: 'importDate',
        key: 'importDate',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY',
        },
        width: 120,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
    ]);

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // ============================================ XỬ LÝ TABS =========================================================

    // ============================================LƯU MẪU BÁO CÁO =====================================================
    const tableRef = useRef<ActionType>();


    // =================================================================================================================
    // Tỉnh/ Thành phố
    const [listProvince, setListProvince] = useState<CommonModel[]>([]);
    // Quận / huyện
    const [listDistrict, setListDistrict] = useState<CommonModel[]>([]);
    // Khu vực
    const [listArea, setListArea] = useState<CommonModel[]>([]);


    const getDataArea = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, "SaleOffice");
      if (commonStore.commonRespone.isSuccess) {
        setListArea(commonStore.commonRespone.data);
      }
    };

    // Tỉnh/ Thành phố
    const getDataProvince = async (area?: string) => {
      await commonPresenter.getListProvince(commonStore, area);
      if (commonStore.commonRespone.isSuccess) {
        setListProvince(commonStore.commonRespone.data);
      }
    };
    // Quận / huyện
    const getDataDistrict = async (province?: string[]) => {
      if (province) {
        await commonPresenter.getListDistrict(commonStore, province);
        if (commonStore.commonRespone.isSuccess) {
          setListDistrict(commonStore.commonRespone.data);
        }
      } else {
        setListDistrict([]);
      }
    };

    // =================================================================================================================
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);

    const [loading, setLoading] = usePartialState({
      loadingSearch: false
    })

    const [listSource, setListSource] = useState<CommonModel[]>([])


    // Lấy danh sách common date
    const getListCommonDate = async () => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
      setLoading({ loadingSearch: false })
    };


    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue("ngayTruyCap", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("ngayTruyCap", undefined);
      }
      setLoading({ loadingSearch: false })
    };

    // console.log('userAgent', window.navigator.userAgent);


    // danh sách nguồn
    const getDataListSource = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, "CustomerSourceAnonymous");
      if (commonStore.commonRespone.isSuccess) {
        setListSource(commonStore.commonRespone.data);
      }
    }

    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };
    useEffect(() => {
      getDataArea()
      getListCommonDate()
      getDataListSource()

      getDataCompany()
    }, [])


    function cleanObject(obj: Record<string, any>): Record<string, any> {
      return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => value !== '' && value !== undefined && value !== null)
      );
    }


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.kh-cdd'),
          },
        ]}
        extras={
          <>
            {/* Tạo chiến dịch */}
            {/* {checkPermission('CREATE') && !!listRowId.length && (
              <Link state={{ state: listRowId }} to={ROUTES.CUSTOMER.CUSTOMER_UNIDENTIFIED.DETAIL.LINK + '?type=create'}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  {t('btn.create-campaign')}
                </CustomButton>
              </Link>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<CustomerUnidentifiedModel>
            bordered
            columns={columns}
            dataSource={dataTable}
            handleResize={() => { }}
            actionRef={tableRef}
            rowSelection={{
              getCheckboxProps(record) {
                return {
                  style: {
                    display: record.isCheck ? '' : 'none'
                  }
                }
              },
              onChange(selectedRowKeys, selectedRows, info) {
                setListRowId(selectedRowKeys)
                if (info.type === 'single') {
                  customerUnindentifiedPresenter.setListIdCustomer(
                    customerUnindentifiedStore,
                    selectedRows.map((r) => r.id),
                  );
                } else if (info.type === 'all') {
                  customerUnindentifiedPresenter.setListIdCustomer(
                    customerUnindentifiedStore,
                    selectedRows.map((r) => r.id),
                  );
                }
              },
            }}
            scroll={{ x: 1500, y: 500 }}
            tableAlertRender={false}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });

              if (Object.values(sort).length) {
                setDataPaging({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
              }
              return {
                data: data,
                success: contactSegmentStore.listContactSegment.isSuccess,
              };
            }}
            headerTitle={
              <div>
                {checkPermission('DELETE') && (
                  <Popconfirm
                    title="Xóa tất cả"
                    description="Bạn có chắc muốn xóa?"
                    okText="Có"
                    onConfirm={async () => {
                      await customerUnindentifiedPresenter.deleteCustomerUnidentified(customerUnindentifiedStore, {
                        ids: listRowId
                      })
                      if (customerUnindentifiedStore.statusApi.isSuccess) {
                        message.success(customerUnindentifiedStore.statusApi.message)
                      } else {
                        message.error(customerUnindentifiedStore.statusApi.message)
                      }
                      tableRef.current?.reload()
                    }}
                    cancelText="Không"
                  >
                    <CustomButton type='primary'>Xóa tất cả</CustomButton>
                  </Popconfirm>
                )}
              </div>
            }
            toolBarRender={() => [
              // EXPORT ====================================================================================
              checkPermission('EXPORT') &&
              <CustomButton
                loading={reportState.loading}
                onClick={async () => {
                  setReportState({ loading: true });
                  const { paging, ...rest } = dataPaging;
                  await customerUnindentifiedPresenter.exportData({ ...rest })
                  setReportState({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>,
              // TẢI MẪU ===================================================================================
              checkPermission('DOWNLOAD') &&
              <CustomButton
                loading={reportState.download}
                onClick={async () => {
                  setReportState({ download: true });
                  await customerUnindentifiedPresenter.downloadTemplateExcel()
                  setReportState({ download: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                Tải mẫu
              </CustomButton>,
              // IMPORT =================================================================
              checkPermission('IMPORT') &&
              <Upload
                disabled={reportState.import}
                // name="FileImport"
                maxCount={1}
                // action={BASE_API_URL + '/Segmentation/import-customer-outside'}
                // headers={{
                //   Authorization: `Bearer ${getAccessToken()}`,
                // }}
                customRequest={async (options) => {
                  const { file, onSuccess, onError } = options;
                  const formData = new FormData();
                  formData.append('FileImport', file);
                  const result = await customerUnindentifiedPresenter.importExcel(formData);
                  if (result) {
                    if (result.isSuccess) {
                      message.success(result.message);
                      setDataPaging({
                        ...dataPaging,
                        paging: {
                          ...dataPaging.paging,
                          pageIndex: 1,
                        },
                      });
                      setReportState({ import: true })
                      await setDataPaging({
                        ...dataPaging,
                        paging: {
                          ...dataPaging.paging,
                          pageIndex: 1,
                        },
                      });
                    } else {
                      message.error(result.message);
                    }
                    setReportState({ import: false })
                  }

                }}
                showUploadList={false}
              >
                <CustomButton type="primary" icon={<UploadIcon className="!fill-white" />}>
                  <label htmlFor="import">{t('btn.import')}</label>
                </CustomButton>
              </Upload>,
            ]}

            rowKey="id"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: customerUnindentifiedStore.listCustomerUnidentified.paging?.totalCount,
            }}
            options={{
              setting: false,
              density: false,
              fullScreen: false,
              reload: false,
            }}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[50%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              loading={loading.loadingSearch}
              onClick={() => {
                const code = form.getFieldValue('customerSegmentationCode');
                const dateAccess = form.getFieldValue('ngayTruyCap');
                const importDate = form.getFieldValue('importDate');


                // lọc bỏ những item có value là rỗng, undefined, null
                const newArr = cleanObject(form.getFieldsValue());

                setDataPaging({
                  // ...form.getFieldsValue(),
                  ...newArr,
                  customerSegmentationCode: Number(code) ? Number(code) : undefined,
                  fromTime: dateAccess && dateAccess[0] ? dayjs(dateAccess[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTime: dateAccess && dateAccess[1] ? dayjs(dateAccess[1])?.format(DATE_FORMAT_POST) : undefined,
                  importDateFrom: importDate && importDate[0] ? dayjs(importDate[0])?.format(DATE_FORMAT_POST) : undefined,
                  importDateTo: importDate && importDate[1] ? dayjs(importDate[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                // onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            column="col-2"
            onFinish={(values) => {
              tableRef.current?.reload();
            }}
          >
            {/* Mã công ty */}
            {/* <SearchItem name={'companyCode'} label={'Company code'}>
              <Input />
            </SearchItem> */}
            <SearchItem
              // rules={[{ required: true }]}
              name={"companyCode"}
              label={"Company code"}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>
            {/* Tên thiết bị */}
            <SearchItem name={'deviceName'} label={t('segment.device')}>
              <Input />
            </SearchItem>
            {/* Số điện thoại */}
            <SearchItem name={'phone'} label={t('unidentified.sdt')}>
              <Input />
            </SearchItem>
            {/* Tên khách hàng */}
            <SearchItem name={'customerName'} label={t('search-form.customer-name')}>
              <Input />
            </SearchItem>
            {/* Nguồn khách hàng */}
            <SearchItem name={'sourceCustomer'} label={t('segment.source-customer')}>
              <CustomSelect
                options={listSource}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </SearchItem>
            {/* Khu vực */}
            <SearchItem name={'area'} label={t('search-form.area')}>
              <CustomSelect
                options={listArea}
                onChange={async (value, option) => {
                  await getDataProvince(option?.key);
                }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                allowClear
              />
            </SearchItem>
            {/* Tỉnh/thành phố */}
            <SearchItem name={'province'} label={t('search-form.province')}>
              <CustomSelect
                mode="multiple"
                options={listProvince}
                onChange={async (value, option) => {
                  if (option.length) {
                    await getDataDistrict(option.map((i: any) => i.key));
                  } else {
                    setListDistrict([]);
                  }
                }}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </SearchItem>
            {/* Quận huyện */}
            <SearchItem name={'district'} label={t('search-form.district')}>
              <CustomSelect
                mode="multiple"
                options={listDistrict}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </SearchItem>

            <SearchItem name={'importDate'} label={'Ngày import'}>
              <RangePicker
                allowEmpty={[true, true]}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>

            {/* Ngày truy cập  */}
            <SearchItem name={"dateAccess"} label={"Ngày truy cập"} start >
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayTruyCap", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem label={' '} colon={false} name={"ngayTruyCap"} >
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>
            {/* Số lượt tải Catalogue */}
            <SearchItem label="Số lượt tải Catalogue" >
              <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                <SearchItem name={'quantityDownloadCTLFrom'} noStyle>
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                </SearchItem>
                <Input
                  className="site-input-split"
                  style={{
                    width: 30,
                    borderLeft: 0,
                    borderRight: 0,
                    pointerEvents: 'none',
                  }}
                  placeholder="~"
                  disabled
                />
                <SearchItem name={'quantityDownloadCTLTo'} noStyle>
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    className="site-input-right"
                    style={{
                      width: "100%",
                      textAlign: 'right',
                    }}
                    placeholder="Đến"
                  />
                </SearchItem>
              </Space.Compact>
            </SearchItem>
            {/* Số lượt sp yêu thích */}
            <SearchItem label="Số lượt sp yêu thích" >
              <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                <SearchItem name={'quantityFavoriteProductFrom'} noStyle>
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                </SearchItem>
                <Input
                  className="site-input-split"
                  style={{
                    width: 30,
                    borderLeft: 0,
                    borderRight: 0,
                    pointerEvents: 'none',
                  }}
                  placeholder="~"
                  disabled
                />
                <SearchItem name={'quantityFavoriteProductTo'} noStyle>
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    className="site-input-right"
                    style={{
                      width: "100%",
                      textAlign: 'right',
                    }}
                    placeholder="Đến"
                  />
                </SearchItem>
              </Space.Compact>
            </SearchItem>

            {/* Mã khách hàng */}
            {/* <SearchItem name={'customerCode'} label={t('segment.ma-kh')}>
              <Input />
            </SearchItem> */}

          </SearchForm>
        </SearchBox>
      </PageWrapper >
    );
  });
};

export default createCustomerUnidentified;
